module.exports = __webpack_public_path__ + "static/media/prima-pagina-news.1be49070.png";